import { memo } from "react";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { InspectionDetails } from "./InspectionDetails";
import { InspectionDetailsContainer$key } from "./__generated__/InspectionDetailsContainer.graphql";

export const InspectionDetailsContainer = memo(function Comp(props: {
  inspectionfield: InspectionDetailsContainer$key;
  onPlan?: Function;
}) {
  const data = useFragment(
    graphql`
      fragment InspectionDetailsContainer on InspectionfieldNode {
        year
        name
        state
        plannedDate
        periodStart
        periodEnd
        assignedDate
        reason
        notes
        latestInspection {
          approvedDate
          rejectedDate
          lastModified
          retryDate
        }
        member {
          name
          phone
          email
          address {
            edges {
              node {
                id
                street
                houseNumber
                zipcode
                city
              }
            }
          }
        }
        managementPackageSetting {
          pdfFileUrl
          displayNameAlt
        }
        field {
          id
          year
          previousId
          member {
            name
            phone
            email
            address {
              edges {
                node {
                  id
                  street
                  houseNumber
                  zipcode
                  city
                }
              }
            }
          }
        }
      }
    `,
    props.inspectionfield
  );
  const { node: address } =
    data?.field?.member?.address?.edges.find((edge) => edge?.node !== null) ||
    {};
  return (
    <InspectionDetails
      state={data.state}
      memberName={data.member?.name}
      memberPhone={data.member?.phone}
      memberEmail={data.member?.email}
      projectName={`${data.managementPackageSetting?.displayNameAlt}`}
      projectPdfUrl={data.managementPackageSetting?.pdfFileUrl}
      periodStart={data.periodStart}
      periodEnd={data.periodEnd}
      plannedDate={data.plannedDate}
      approvedDate={data?.latestInspection?.approvedDate}
      rejectedDate={data?.latestInspection?.rejectedDate}
      assignedDate={data?.assignedDate}
      lastModified={data?.latestInspection?.lastModified}
      retryDate={data?.latestInspection?.retryDate}
      reason={data?.reason}
      notes={data?.notes}
      address={
        address
          ? {
              street: address.street,
              houseNumber: address.houseNumber,
              city: address.city,
              zipcode: address.zipcode,
            }
          : null
      }
      year={data.year}
      onPlan={props.onPlan}
    />
  );
});
